import React, { useState } from 'react';

import Buttons from './Buttons';
import CommonModal from './CommonModal';
import CustomChart from './CustomChart';
import Filter from './Filter';
import Input from './Input';
import MainHeader from './MainHeader';
import ProductSlide from './ProductSlide';
import Table from './Table';
import TechPack from './TechPack';
import TopHeaderUi from './TopHeaderUi';
import UiComponent from './UiComponent';
const ComponentWrapper = () => {
	const [activeTab, setActiveTab] = useState('Ui components');
	const uiTabs = [
		'Ui components',
		'Buttons',
		'Table',
		'Filter',
		'Input',
		'Common Modal',
		'Custom Chart',
		'Product Slide',
		'Tech Pack'
	];

	const renderComponents = () => {
		switch (activeTab) {
			case 'Ui components':
				return <UiComponent />;
			case 'Buttons':
				return <Buttons />;
			case 'Table':
				return <Table />;
			case 'Filter':
				return <Filter />;
			case 'Input':
				return <Input />;
			case 'Common Modal':
				return <CommonModal />;
			case 'Custom Chart':
				return <CustomChart />;
			case 'Product Slide':
				return <ProductSlide />;
			case 'Tech Pack':
				return <TechPack />;
			default:
				return null;
		}
	};

	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default ComponentWrapper;
